module.exports = __webpack_public_path__ + "static/media/joseph_head.aa86d418.png";